import DOMPurify from "dompurify";
const sanitizeConfig = {
    ALLOWED_TAGS: [
        "br",
        "b",
        "strong",
        "i",
        "u",
        "a",
        "p",
        "ul",
        "ol",
        "li",
        "table",
        "thead",
        "tbody",
        "tr",
        "th",
        "td",
        "iframe"
    ],
    ALLOWED_ATTR: [
        "href",
        "src"
    ],
    ADD_TAGS: [
        "iframe"
    ],
    FORCE_BODY: true
};
DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    // <a href="..."> → HTTPS only
    if (node.tagName === "A" && data.attrName === "href") {
        try {
            const url = new URL(data.attrValue, window.location.origin);
            if (url.protocol !== "https:")
                data.keepAttr = false;
        }
        catch {
            data.keepAttr = false;
        }
    }
    // <iframe src="..."> → YouTube embed only
    if (node.tagName === "IFRAME" && data.attrName === "src") {
        try {
            const url = new URL(data.attrValue);
            const isYoutubeEmbed = url.protocol === "https:"
                && (url.hostname === "www.youtube.com" || url.hostname === "youtube.com")
                && url.pathname.startsWith("/embed/");
            if (!isYoutubeEmbed)
                data.keepAttr = false;
        }
        catch {
            data.keepAttr = false;
        }
    }
});
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.hasAttribute("href")) {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
    }
    if (node.tagName === "IFRAME" && node.hasAttribute("src")) {
        node.setAttribute("frameborder", "0");
        node.setAttribute("allowfullscreen", "");
    }
});
// NOTE: Product with ID 2008 dynamically generates its URL via a script.
// Scripts are not allowed, so this function handles it for this particular product.
// Since this is the only known case, this function works, and other scripts that use const urlMapping will probably do too.
// If later more products use a different kind of dynamic URL generation, this function may need to be updated accordingly.
const extractUrlFromScript = (html) => {
    const urlMappingsMatch = html.match(/urlMappings\s*=\s*\{([^}]*)\}/s);
    if (!urlMappingsMatch)
        return html;
    const urlMatches = html.match(/'(https:\/\/[^']+)'/g);
    if (!urlMatches || urlMatches.length === 0)
        return html;
    const firstUrl = urlMatches[0].slice(1, -1);
    return html.replace(/href="#"/g, `href="${firstUrl}"`);
};
export const purifyRichtext = (html) => {
    if (!html || typeof html !== 'string')
        return html;
    const withUrls = extractUrlFromScript(html);
    return DOMPurify.sanitize(withUrls, sanitizeConfig);
};
